import { Input, Directive, OnInit } from '@angular/core';
import { BaseValidator } from './base.directive';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { TranslationService } from '../../common/services/translation.service';
import { BlockedUsersService } from '../../common/services/blocked-users.service';

@Directive({
    selector: '[cpqBlockedUser]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CpqBlockedUserDirective, multi: true }],
    standalone: false
})
export class CpqBlockedUserDirective extends BaseValidator implements Validator, OnInit {

    public blockedUsersIds = new Array<number>();
    constructor(private translationService: TranslationService, private blockedUsersService: BlockedUsersService) {
        super();
    }

    ngOnInit() {
        this.blockedUsersService.getBlockedUsers().subscribe(blockedUsersIds => {
            this.blockedUsersIds = blockedUsersIds;
          });
    }

    validate(c: AbstractControl): { [key: number]: any; } {
        if (c.value) {
            if (!this.isUserBlocked(c.value)) {
                return null;
            } else {
                c.markAsTouched();
                return this.createMessage(ValidationTypes.cpqBlockedUser, this.translationService.translate('Admin.Validation.BlockedUser'));
            }
        }
    }

    isUserBlocked(userId: number) {
        return this.blockedUsersIds.indexOf(+userId) > -1;
    }
}
